import React from 'react';

import { useTranslation } from 'react-i18next';

import { UiButton } from '@shared/ui';

import cls from './AutoPlanningModal.module.css';
import { DayInput } from '../../UI/DayInput/DayInput';
import Modal from '../../UI/Modal/Modal';
import { ModalBody } from '../../UI/Modal/ModalBody/ModalBody';
import { ModalFooter } from '../../UI/Modal/ModalFooter/ModalFooter';

export const AutoPlanningModal = ({
    isOpen,
    onShowChange,
    setAutOPlanningForm,
    autOPlanningForm,
    autoPlanningMhd,
    isPlanFact,
}) => {
    const onHideModal = () => {
        onShowChange(false);
    };

    const { t } = useTranslation();

    const onChangeInput = (value) => {
        setAutOPlanningForm({ days: value });
    };

    const onPlan = () => {
        if (!isPlanFact) {
            $.ajax({
                url: `${routable.getRoute('estimateScheduleSaveSettings')}?viewMaterial=1`,
                success() {},
            });
        }
        autoPlanningMhd(autOPlanningForm);
        onHideModal();
    };

    return (
        <Modal isOpen={isOpen} onHideModal={onHideModal}>
            <ModalBody width="368px">
                <div className={cls.body}>
                    <div className={cls.header}>
                        {t('AutoPlanningModal.return.header.part1')}
                        <br />
                        {t('AutoPlanningModal.return.header.part2')}
                    </div>
                    <div className={cls.subTitle}>
                        {t('AutoPlanningModal.return.subTitle.part1')}
                        <br />
                        {t('AutoPlanningModal.return.subTitle.part2')}
                    </div>
                    <div className={cls.setting}>
                        <div className={cls.settingContent}>
                            <DayInput
                                onChange={onChangeInput}
                                value={`${autOPlanningForm.days}`}
                                classes={cls.inputModal}
                            />
                            <span>{t('AutoPlanningModal.return.settingContent.span')}</span>
                        </div>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <div className={cls.footer}>
                    <UiButton
                        btnText={t('AutoPlanningModal.return.footer.cancel')}
                        btnColor="secondary"
                        onClick={onHideModal}
                    />
                    <UiButton
                        btnText={t('AutoPlanningModal.return.footer.planing')}
                        onClick={onPlan}
                    />
                </div>
            </ModalFooter>
        </Modal>
    );
};
